module.exports = __webpack_public_path__ + "img/quanyi.8e69cff2.png";